import { Model } from '../Model.js';
import { UserPolicies } from './UserPolicies.js';

var _dec, _class;

/**
 * Plain object User representation.
 */

/**
 * Serialized object User representation.
 */

/**
 * Plain object Packlink's API response representation.
 */

let User = (_dec = Model(), _dec(_class = class User {
  /**
   * Takes a IUserApiResponse from Packlink's API and returns a User.
   *
   * @param response  IUserApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new User(response.country, response.client_id || response.identifier, response.email, response.identifier, response.language, response.platform, response.platform_country, response.tenant_id, UserPolicies.createFromResponse(response.policies));
  }

  /**
   * Takes a serialized User and returns a User.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized User.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedUser.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of User.
   *
   */

  /**
   * Takes a serialized User and returns a User.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized User.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedUser.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of User.
   *
   */

  /**
   * Takes a serialized User and returns a User.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized User.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedUser.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of User.
   *
   */

  /**
   * Takes a serialized User and returns a User.
   *
   * It allows you to hint the type of data via type params.IUserPolicies
   *
   * @typeparam U  Type of the deserialized User.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedUser.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of User.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new User(data.alpha2Code, data.clientId, data.email, data.id, data.language, data.platform, data.platformCountry, data.tenantId, UserPolicies.deserialize(data.policies));
  }

  /**
   * Returns a new User. Typings of the properties depend on the class type param T
   *
   */
  constructor(alpha2Code, clientId, email, id, language, platform, platformCountry, tenantId, policies) {
    this.alpha2Code = alpha2Code;
    this.clientId = clientId;
    this.email = email;
    this.id = id;
    this.language = language;
    this.platform = platform;
    this.platformCountry = platformCountry;
    this.tenantId = tenantId;
    this.policies = policies;
  }

  /**
   * Returns a JSON serialized version of the User.
   *
   */
  toJSON() {
    var _this$policies;
    return {
      alpha2Code: this.alpha2Code,
      clientId: this.clientId,
      email: this.email,
      id: this.id,
      language: this.language,
      platform: this.platform,
      platformCountry: this.platformCountry,
      tenantId: this.tenantId,
      policies: (_this$policies = this.policies) === null || _this$policies === void 0 ? void 0 : _this$policies.toJSON()
    };
  }

  /**
   * Returns a clone of the User.
   *
   */
  clone() {
    var _this$policies2;
    return new User(this.alpha2Code, this.clientId, this.email, this.id, this.language, this.platform, this.platformCountry, this.tenantId, (_this$policies2 = this.policies) === null || _this$policies2 === void 0 ? void 0 : _this$policies2.clone());
  }

  /**
   * Returns whether the two User are equal.
   *
   */
  equals(user) {
    var _this$policies3;
    if (!user) {
      return false;
    }
    return this.alpha2Code === user.alpha2Code && this.clientId === user.clientId && this.email === user.email && this.id === user.id && this.language === user.language && this.platform === user.platform && this.platformCountry === user.platformCountry && this.tenantId === user.tenantId && (this.policies === undefined && user.policies === undefined ? true : !!((_this$policies3 = this.policies) !== null && _this$policies3 !== void 0 && _this$policies3.equals(user.policies)));
  }
}) || _class);

export { User };
//# sourceMappingURL=User.js.map
